module.exports = __webpack_public_path__ + "static/quality.3ab2b4ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/quality.png
// module id = 178
// module chunks = 12729642909824 213628377533538